import { Component } from "react";
import { Sparkles } from "lucide-react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-6" data-testid="error-boundary-fallback">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center">
              <Sparkles className="w-8 h-8 text-red-500" />
            </div>
            <h1 className="font-outfit text-2xl text-foreground mb-2">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-6">An unexpected error occurred. Please refresh the page.</p>
            <button
              onClick={() => { this.setState({ hasError: false }); window.location.href = "/"; }}
              className="px-6 py-2.5 bg-gradient-to-r from-cyan-400 to-violet-500 text-white rounded-lg hover:-translate-y-0.5 transition-all cursor-pointer shadow-glow-sm"
              data-testid="error-boundary-home-btn"
            >
              Go Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
